
export const INIT_CLASSIFY_LIST = "init_classify_list";
export const PLAN_INDEX = "plan_index";
export const PLAN_DATA = "plan_data";
export const PLAN_CAROUSEL = "plan_carousel";
